
import { RestoreBackupDto } from '@/services/Backup/interfaces/index';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RestoreBackupDialog extends Vue {
  @Prop()
  public readonly data!: RestoreBackupDto;

  public visible: boolean = true;

  get message(): string {
    return `Are you sure you want to restore this Backup: ${this.data.websiteBackupId}?`;
  }

  public loading = false;
  public restoreConfigs: {[index: string]: boolean} = {};
  public restoreTargets: {[index: number]: boolean} = {};

  public async created(): Promise<void> {
    this.loading = true;
    this.restoreConfigs = {};
    for (const key of Object.keys(this.data.config)) {
      this.restoreConfigs[key] = true;
    }
    this.restoreTargets = {};
    for (const target of this.data.targets) {
      this.restoreTargets[target.id] = true;
    }

    this.loading = false;
  }

  public async restoreBackup(): Promise<void> {
    if (Object.values(this.restoreTargets).filter(value => value).length <= 0 && Object.values(this.restoreConfigs).filter(value => value).length <= 0) {
      this.$errorDialog.show('Please select at least one option to restore.');
      return;
    }

    this.data.options = {
      restoreConfigTypes: Object.entries(this.restoreConfigs).filter(([_, bool]) => bool).map(([config, _]) => config),
      restoreBackupTargets: Object.entries(this.restoreTargets).filter(([_, bool]) => bool)
        .map(([targetId, _]) => this.data.targets.filter(x => x.id === parseInt(targetId)).pop())
        .filter(x => x !== undefined)
        .map(x => x!.id)
    };

    this.$emit('restore', this.data);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');
  }
}
